import { AlertsCounter } from '@app/shared/components/alerts-counter';
import { ImpersonationIndication } from '@app/shared/components/impersonation-indication';
import { DownloadAppButton } from '@app/shared/components/layout/download-app-button';
import { useImpersonation } from '@contexts/impersonation-context';
import { useCurrentUser } from '@hooks/use-current-user';
import type { RefineThemedLayoutHeaderProps } from '@refinedev/antd';
import { Flex, Layout as AntdLayout, Space, theme, Typography } from 'antd';

const { Text } = Typography;
const { useToken } = theme;

export const Header: React.FC<RefineThemedLayoutHeaderProps> = ({ sticky = true }) => {
  const { token } = useToken();

  const user = useCurrentUser();
  const { isImpersonating } = useImpersonation();

  const headerStyles: React.CSSProperties = {
    backgroundColor: token.colorBgElevated,
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    padding: isImpersonating ? '0px' : '0px 32px',
    width: isImpersonating ? '100%' : 'unset',
    height: '56px',
    borderBottom: `1px solid ${token.colorBorderSecondary}`,
  };

  if (sticky) {
    headerStyles.position = 'sticky';
    headerStyles.top = 0;
    headerStyles.zIndex = 2;
  }

  return (
    <AntdLayout.Header style={headerStyles}>
      {isImpersonating ? (
        <ImpersonationIndication />
      ) : (
        <Flex align="center" gap={16}>
          <DownloadAppButton />
          <AlertsCounter />
          <div style={{ borderLeft: '1px solid #AFB7C1', height: 20 }} />
          {user?.name && (
            <Space size="middle" style={{ marginLeft: '8px' }}>
              {user?.name && <Text strong>{user.name}</Text>}
            </Space>
          )}
        </Flex>
      )}
    </AntdLayout.Header>
  );
};
